import * as fs from 'node:fs/promises';

export const writeJsonl = (absolutePath: string, lines: ReadonlyArray<unknown>): Promise<void> =>
  fs.writeFile(
    absolutePath,
    lines.length === 0 ? '' : `${lines.map((l) => JSON.stringify(l)).join('\n')}\n`,
    'utf-8'
  );

export const writeJson = (absolutePath: string, value: unknown): Promise<void> =>
  fs.writeFile(absolutePath, `${JSON.stringify(value, null, 2)}\n`, 'utf-8');

export const writeText = (absolutePath: string, text: string): Promise<void> =>
  fs.writeFile(absolutePath, text, 'utf-8');

export const isoToMs = (iso: string | null): number | null => {
  if (!iso) return null;
  const parsed = Date.parse(iso);
  return Number.isFinite(parsed) ? parsed : null;
};

export const isObject = (v: unknown): v is Record<string, unknown> =>
  v !== null && typeof v === 'object' && !Array.isArray(v);
